const subscribers = new Set()
let started = false
let loading = null

export function observeNexoVitals(report) {
  subscribers.add(report)
  if (!started && !loading) {
    loading = import('web-vitals').then(({ onLCP, onINP, onCLS }) => {
      if (!subscribers.size) return
      started = true
      const notify = metric => { for (const subscriber of subscribers) { try { subscriber(metric) } catch { /* Observation cannot affect the page. */ } } }
      onLCP(notify); onINP(notify); onCLS(notify)
    }).catch(() => {}).finally(() => { loading = null })
  }
  return () => subscribers.delete(report)
}
